<div [ngClass]="chipFrequenciesChoice ? 'scheduler-column-container' : 'scheduler-row-container'"
    [formGroup]="_freqScheduler.schedulerForm" style="--color: {{theme}}">

    <div class="freq-chips-container" *ngIf="chipFrequenciesChoice">
        <mat-chip-listbox #chipList [selectable]="true">
            <mat-chip-option *ngFor="let freq of listFrequencies" [color]="chipColorChange(freq)"
                style="background-color: #e0e0e0;" (click)="changeFrequency(freq, true)">
                {{ "FREQUENCY." + freq | translate }}
            </mat-chip-option>
        </mat-chip-listbox>
    </div>

    <!-- Frequency Select -->
    <mat-form-field class="freq-select-container" *ngIf="!chipFrequenciesChoice" [appearance]="appearance">
        <mat-label>{{ labelsTranslations[0] | translate }}</mat-label>
        <mat-select required formControlName="frequencyControl" (selectionChange)="changeFrequency($event.value, true)">
            <mat-option *ngFor="let freq of listFrequencies" [value]="freq">
                {{ "FREQUENCY." + freq | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="selects-container">
        <!-- Month Select -->
        <mat-form-field class="month-select-container" *ngIf="showSelect.month" [appearance]="appearance">
            <mat-label>{{ labelsTranslations[1] | translate }}</mat-label>
            <mat-select required formControlName="monthControl" (selectionChange)="selectionChange('month')">
                <mat-option *ngFor="let month of listMonth" [value]="formatMonth(month)">
                    {{ month | titlecase }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Select day of the week -->
        <mat-form-field class="weekDay-select-container" *ngIf="showSelect.weekDay" [appearance]="appearance">
            <mat-label>{{ labelsTranslations[2] | translate }}</mat-label>
            <mat-select required formControlName="weekDayControl" (selectionChange)="selectionChange()">
                <mat-option *ngFor="let weekDay of listWeekDays" [value]="weekDay">
                    {{ weekDay | titlecase }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Select day -->
        <mat-form-field class="day-select-container" *ngIf="showSelect.day" [appearance]="appearance">
            <mat-label>{{ labelsTranslations[3] | translate }}</mat-label>
            <mat-select required formControlName="dayControl" (selectionChange)="selectionChange()">
                <mat-option *ngFor="let day of listNumberDays" [value]="day">
                    {{ day }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Select Hour -->
        <mat-form-field class="hour-input-container" *ngIf="showSelect.hours" [appearance]="appearance">
            <input matInput required formControlName="hourControl" placeholder="{{ labelsTranslations[4] | translate }}"
                [ngxTimepicker]="picker" [format]="24">

            <ngx-material-timepicker #picker (closed)="selectionChange()">
            </ngx-material-timepicker>

            <ngx-material-timepicker-toggle matSuffix [for]="picker">
            </ngx-material-timepicker-toggle>
        </mat-form-field>

        <!-- Select minute -->
        <mat-form-field class="minute-select-container" *ngIf="showSelect.minute" [appearance]="appearance">
            <mat-label>{{ labelsTranslations[5] | translate }}</mat-label>
            <mat-select required formControlName="minuteControl" (selectionChange)="selectionChange()">
                <mat-option *ngFor="let minute of listMinute" [value]="minute">
                    {{ minute }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>